
import {Vue, Component} from 'vue-property-decorator'

@Component({components : {}})
export default class DevBar extends Vue {
  menu : boolean = false
}
